import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  actionBarToolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  leftButtons: {
    marginLeft: -theme.spacing(0.5),
    marginRight: -theme.spacing(0.5),
    "&> *": {
      margin: [theme.spacing(0, 0.5), "!important"],
    },
  },
  rightContent: {
    display: "flex",
    alignItems: "center",
  },
  actionsMobileMenu: {
    minWidth: [120, "!important"],
  },
  toolbarGutters: {
    padding: [theme.spacing(0, 2), "!important"],
  },
}))

export default styles
